"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiErrorSerializers = exports.apiErrorSerializer = exports.stdErrSerializerWithCause = exports.serializeDeliverrError = exports.serializeAxiosError = exports.serializeAxiosResponse = void 0;
const _ = require("lodash");
const bunyan = require("bunyan");
const LogsUtils_1 = require("./LogsUtils");
function isAxiosError(err) {
    return (_.isError(err) &&
        _.has(err, ["config", "method"]) &&
        (_.has(err, ["config", "url"]) || _.has(err, ["config", "baseURL"])) &&
        _.has(err, ["config", "headers"]) &&
        _.has(err, ["response", "status"]) &&
        _.has(err, ["response", "statusText"]) &&
        _.has(err, ["response", "headers"]));
}
function serializeAxiosResponse(response) {
    return {
        data: Buffer.isBuffer(response.data) ? response.data.toString() : response.data,
        statusCode: response.status,
        statusText: response.statusText,
        headers: response.headers,
        request: {
            method: response.config.method,
            url: extractURL(response),
            headers: response.config.headers,
            data: Buffer.isBuffer(response.config.data) ? response.config.data.toString() : response.config.data,
        },
    };
}
exports.serializeAxiosResponse = serializeAxiosResponse;
function extractURL(response) {
    var _a;
    const url = (_a = response.config.url) !== null && _a !== void 0 ? _a : response.config.baseURL;
    return url ? new URL(url, response.config.baseURL).href : undefined;
}
function getErrorStack(err) {
    let ret = err.stack || err.toString();
    if (err.cause && typeof err.cause === "function") {
        const cex = err.cause();
        if (cex) {
            ret += "\nCaused by: " + getErrorStack(cex);
        }
    }
    return ret;
}
function serializeAxiosError(err) {
    return {
        message: err.message,
        name: err.name,
        response: serializeAxiosResponse(err.response),
        callstack: getErrorStack(err),
    };
}
exports.serializeAxiosError = serializeAxiosError;
function serializeDeliverrError(err) {
    const serializedErr = {
        code: err.code,
        subcode: err.subcode,
        functionName: err.functionName,
        payload: err.payload,
        silenceBugsnag: err.silenceBugsnag,
        message: err.message,
        name: err.name,
        callstack: err.stack,
    };
    const serializedCause = serializeDeliverrErrorCauseNonRecursive(err);
    if (serializedCause) {
        serializedErr.cause = serializedCause;
    }
    return serializedErr;
}
exports.serializeDeliverrError = serializeDeliverrError;
function serializeDeliverrErrorCauseNonRecursive(err) {
    if (err.hasOwnProperty("cause") && err.cause !== err) {
        const cause = err.cause;
        const serializedCause = isAxiosError(cause) ? serializeAxiosError(cause) : bunyan.stdSerializers.err(cause);
        return serializedCause;
    }
    return undefined;
}
function isDeliverrError(err) {
    return (0, LogsUtils_1.HasConstructorInClassHierarchy)(err, "DeliverrError");
}
function stdErrSerializerWithCause(err) {
    return Object.assign(Object.assign({}, bunyan.stdSerializers.err(err)), { cause: err.cause });
}
exports.stdErrSerializerWithCause = stdErrSerializerWithCause;
function apiErrorSerializer(err) {
    return isAxiosError(err)
        ? serializeAxiosError(err)
        : isDeliverrError(err)
            ? serializeDeliverrError(err)
            : stdErrSerializerWithCause(err);
}
exports.apiErrorSerializer = apiErrorSerializer;
exports.apiErrorSerializers = {
    err: apiErrorSerializer,
    error: apiErrorSerializer,
};
//# sourceMappingURL=ApiErrorSerializers.js.map